<template>
  <div>
    <el-submenu v-if="hasChildren" :index="itemIndex" class="el-sub-menu-l">
      <template slot="title">
        <div
          class="role-menu-title"
          :class="{ 'is-disabled': role.isLoginIn }"
          @click.stop="handleClick"
        >
          <img v-if="role.logoPath" :src="role.logoPath" class="role-logo" />
          <i v-else class="el-icon-user role-icon"></i>
          <div class="role-text">
            {{role.adminName}}({{ role.roleName }}) 
            
          </div>
          <el-tag v-if="role.adminState == 2" type="info">离职</el-tag>
          <span v-if="role.isLoginIn" class="current-role-tag">当前</span>
        </div>
      </template>

      <RoleMenuItem
        v-for="child in children"
        :key="childKey(child)"
        :role="child"
        :navigate="navigate"
        :parent-index="itemIndex"
      />
    </el-submenu>

    <el-menu-item v-else :index="itemIndex" :disabled="role.isLoginIn" @click="handleClick" class="el-sub-menu-l">
      <div class="role-menu-item">
        <img v-if="role.logoPath" :src="role.logoPath" class="role-logo" />
        <i v-else class="el-icon-user role-icon"></i>
        <div class="role-text">
          {{role.adminName}}({{ role.roleName }})
        </div>
        <el-tag v-if="role.adminState == 2" type="info">离职</el-tag>
        <span v-if="role.isLoginIn" class="current-role-tag">当前</span>
      </div>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: "RoleMenuItem",
  props: {
    role: { type: Object, required: true },
    navigate: { type: Function, required: true },
    parentIndex: { type: String, default: "" },
  },
  computed: {
    children() {
      const rawChildren = this.role?.childs;
      if (Array.isArray(rawChildren)) return rawChildren;
      if (rawChildren == null) return [];
      if (typeof rawChildren === "object") return [rawChildren];
      return [];
    },
    hasChildren() {
      return Array.isArray(this.children) && this.children.length > 0;
    },
    nodeId() {
      const roleId = this.role?.roleId;
      const adminId = this.role?.adminId;
      if (roleId != null && adminId != null) return `${roleId}-${adminId}`;
      if (roleId != null) return String(roleId);
      if (adminId != null) return String(adminId);
      if (this.role?.pcSiteUrl) return String(this.role.pcSiteUrl);
      return `${this.role?.roleName || ""}-${this.role?.adminName || ""}`;
    },
    itemIndex() {
      // Element Plus 的 submenu 展开状态用 index 作为 key；index 重复会导致“点一个展开多个”。
      return this.parentIndex ? `${this.parentIndex}/${this.nodeId}` : this.nodeId;
    },
  },
  methods: {
    childKey(child) {
      const childRoleId = child?.roleId;
      const childAdminId = child?.adminId;
      const childId =
        childRoleId != null && childAdminId != null
          ? `${childRoleId}-${childAdminId}`
          : childRoleId != null
          ? String(childRoleId)
          : childAdminId != null
          ? String(childAdminId)
          : child?.pcSiteUrl
          ? String(child.pcSiteUrl)
          : `${child?.roleName || ""}-${child?.adminName || ""}`;
      return `${this.itemIndex}/${childId}`;
    },
    handleClick(e) {
      console.log(this.role.pcSiteUrl, this.role,'ffff')
      e?.stopPropagation?.();
      if (!this.role.isLoginIn) {
        this.navigate(this.role.pcSiteUrl, this.role);
      }
    },
  },
};
</script>

<style scoped>
.role-menu-title,
.role-menu-item {
  display: flex;
  align-items: center;
  width: 95%;
  gap: 8px;
  height: 48px;
  /* margin-right: 16px; */
  font-size: 14px;
  box-sizing: border-box;
}

.role-menu-title {
  cursor: pointer;
  border-bottom: 1px solid #f0f2f5;
}

.role-text {
  /* flex: 1; */
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  margin-right: 16px;
}
.role-logo{
  width: 20px;
  height: 20px;
  border-radius: 50%;
  /* margin-right: 12px; */
  object-fit: cover;
}
.role-icon {
  margin-right: 12px;
  font-size: 18px;
  color: #909399;
}

.is-disabled {
  color: var(--el-text-color-disabled);
  cursor: not-allowed;
}
::v-deep .el-sub-menu-l{
    border-bottom: 1px solid #f0f2f5;
}
.role-menu-item:last-child {
  border-bottom: none;
}
/* 叶子菜单项（el-menu-item）本身带 el-sub-menu-l 类，需用同级选择器才会生效 */
::v-deep .el-menu-item.el-sub-menu-l {
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #f0f2f5 !important;
}
::v-deep .el-sub-menu-l > .el-submenu__title {
  height: 48px;
  line-height: 48px;
  padding: 0 16px;
  font-size: 14px;
  color: #303133;
  border-bottom: 1px solid #f0f2f5 !important;
}
::v-deep .el-sub-menu-l {
  width: 100%;
}
::v-deep .el-sub-menu-l > .el-submenu__title .el-submenu__icon-arrow {
  right: 10px;
  color: #c0c4cc;
}
::v-deep .el-sub-menu-l > .el-submenu__title:hover,
::v-deep .el-sub-menu-l > .el-submenu__title:focus {
  background: #f5f7fa;
}
::v-deep .el-sub-menu-l .el-menu-item {
  height: 48px;
  line-height: 48px;
  padding-left: 40px !important;
  padding-right: 20px !important;
  font-size: 14px;
  color: #303133;
  border-bottom: 1px solid #f0f2f5 !important;
}

/* 兜底：递归子级展开后的二级/多级 menu-item 也要有分割线 */
::v-deep .el-menu-item {
  border-bottom: 1px solid #f0f2f5;
}
::v-deep .el-sub-menu-l .el-menu-item:hover,
::v-deep .el-sub-menu-l .el-menu-item:focus {
  /* background: #f5f7fa; */
}
</style>
